exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv#image_overlay_panel {\r\n    z-index: 2000 !important;\n}\n.vc-alpha {\r\n    display: none;\n}\n.dict-stat-table .badge {\r\n    border-radius:0;\n}\n.dict-stat-table .badge-success, .dict-stat-table .badge-danger {\r\n    width: 40px;\n}\r\n", ""]);

// exports
